import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useForceResyncEvents(
  googleCalendarIntegrationId: string,
): UseMutationResult<AxiosResponse<void>, AxiosError<ErrorMessage>> {
  const mutationFn = useCallback((): Promise<AxiosResponse<void>> => {
    return client.put(`google-calendar-integrations/${googleCalendarIntegrationId}/resync-events/`);
  }, [googleCalendarIntegrationId]);

  return useMutation(mutationFn);
}
